import React, { FC } from 'react';
import moment from 'moment/moment';
import { getACHRelationships } from './api';
import { useAsyncData } from '@shared/react';
import { combineFilterWithOp } from '@shared/utils';
import './AccountACH.scss';

interface IAccountACH {
    accountID: number;
}

export const AccountACH: FC<IAccountACH> = ({ accountID }) => {
    const { data: achRelationships } = useAsyncData(
        async () => {
            const filter = {
                AccountId: { value: accountID, operator: '=' },
            };
            const { items } = await getACHRelationships({
                filter: combineFilterWithOp(filter),
            });
            return items || [];
        },
        [],
        [],
    );

    return (
        <div className='account-ach-list'>
            {achRelationships?.map((ach) => (
                <div className='account-ach-list__item'>
                    <div className='account-ach-list__item__column'>
                        <div className='account-ach-list__item__title'>Name:</div>
                        <div className='account-ach-list__item__title'>Routing Number:</div>
                        <div className='account-ach-list__item__title'>Account Number:</div>
                        <div className='account-ach-list__item__title'>Created at:</div>
                    </div>

                    <div className='account-ach-list__item__column'>
                        <div className='account-ach-list__item__value'>{ach.alias}</div>
                        <div className='account-ach-list__item__value'>{ach.routingNumber}</div>
                        <div className='account-ach-list__item__value'>{ach.accountNumber}</div>
                        <div className='account-ach-list__item__value'>
                            {moment(ach.createdAt).format('MMMM DD, YYYY')}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
